import Typography from '@mui/material/Typography';
import { LinkPreview } from '@dhaiwat10/react-link-preview';
import { toSafeHttpUrl } from 'app/shared-components/util/safeHttpUrl';

// LinkPreview opens its `url` with window.open() when the card is clicked, and
// window.open('javascript:...') runs script in this origin. Post and message link URLs are
// user-supplied, so only an http(s) URL reaches the library; anything else is shown as text.
//
// The library calls window.open(url, '_blank'), which leaves window.opener pointing at this
// page, so the opened (user-supplied) page could redirect it. The click on the card is taken
// first, in the capture phase, and the same URL is opened without an opener. Only the card is
// intercepted: a click on the fallback content keeps its normal link behaviour.
export default function SafeLinkPreview({ url, ...props }) {
  const safeUrl = toSafeHttpUrl(url);
  if (!safeUrl) return <Typography className="break-all">{url}</Typography>;

  const openWithoutOpener = (event) => {
    if (!event.target.closest || !event.target.closest('[data-testid="container"]')) return;
    event.stopPropagation();
    window.open(safeUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div onClickCapture={openWithoutOpener}>
      <LinkPreview url={safeUrl} {...props} />
    </div>
  );
}
